var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltip)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.title)+" ")])]}}],null,false,859499058)},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])]):_c('span',[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }